import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from "@angular/core";
import { catchError, Observable, throwError } from 'rxjs';
import { IResponseError } from "../enums/types";
import { AuthService } from '../service/auth.service';

export const httpMadhuramAdminJwtInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    return next(req).pipe(catchError(error => {
        // console.log('==============================================');
        // console.log(JSON.parse(JSON.stringify(error)));
        // console.log('==============================================');

        if (error.status === 401) {
            const errors: IResponseError[] = error && error.error && error.error.errors ? error.error.errors : [];
            if (errors.length && errors[0].message === 'Password changed.') {
                authService.logout();
            } else if (errors.length && errors[0].message === 'Invalid JWT token provided.') {
                authService.logout();
            } else if (errors.length && errors[0].message === 'API user not found.') {
                authService.logout();
            } else {
                authService.logout();
            }
        } else if (error.status === 400) {
            const errors = error && error.error && error.error.errors ? error.error.errors : [];
            if (errors.length && errors[0].message.indexOf('Please provide valid API path') >= 0) {
                authService.logout();
            }
        }
        return throwError(error);
    }));
};
